import {
	ISSUE_ASSIGNED_EVENT,
	ISSUE_CREATED_EVENT,
	ISSUE_DELETED_EVENT,
	ISSUE_TRANSITIONED_EVENT,
	ISSUE_UPDATED_EVENT,
	ISSUE_PARENT_ASSOCIATION_EVENT,
} from '@atlassian/jira-realtime/src/common/constants/events.tsx';
import type { RealtimeEventType } from '@atlassian/jira-realtime/src/common/types/events.tsx';

export const APP_ID = 'software.backlog-panel';

export const DIVIDER_DRAGGABLE_ID_PREFIX = 'DIVIDER_DRAGGABLE_ID';
export const ANALYTICS_SOURCE_EPIC_PANEL = 'epic panel';
export const EXPERIENCE_TRACKER_PROVIDER_SOURCE = 'epicPanel';

export const EPIC_PANEL_VIEW_EXPERIENCE = 'viewEpicPanel';
export const EPIC_PANEL_INLINE_ISSUE_CREATE_EXPERIENCE = 'createInlineIssueEpicPanel';
export const EPIC_PANEL_GLOBAL_ISSUE_CREATE_EXPERIENCE = 'createGlobalIssueEpicPanel';
export const EPIC_PANEL_ASSIGN_EXPERIENCE = 'assignEpicPanel';
export const EPIC_PANEL_UNASSIGN_EXPERIENCE = 'unassignEpicPanel';
export const EPIC_PANEL_RANK_EXPERIENCE = 'rankCardEpicPanel';

export const ABORT_EXPERIENCE_MISSING_REQUIRED_FIELD_REASON = 'require-field-missing';
export const ABORT_EXPERIENCE_CANCELED_BY_USE_REASON = 'global-issue-create-canceled-by-user';

export const EPIC_DRAGGABLE_ID_PREFIX = 'EPIC_DRAGGABLE_ID' as const;

export const EPIC_PANEL_DROPPABLE_ID = 'EPIC_PANEL';
export const EPIC_PANEL_DROPPABLE_TYPE = 'EPIC_PANEL';

// the panel card droppable type must match the backlog droppable type
export const CARD_DROPPABLE_TYPE = 'CARD';
export const CARD_GROUP_DROPPABLE_TYPE = 'CARD-GROUP';
export const EPIC_PREFIX = 'EPIC-';
export const VERSION_PREFIX = 'VERSION-';

export const DEFAULT_PARENT_ISSUE_TYPE_NAME = 'Epic';
export const UNASSIGNED_EPIC_ID = 0;
export const UNASSIGNED_EPIC_ISSUE_KEY = 'ISK-0';

export const CREATE_ISSUE_PERMISSION = 'CREATE_ISSUE';
export const EDIT_ISSUE_PERMISSION = 'EDIT_ISSUE';

export const REALTIME_EVENTS: RealtimeEventType[] = [
	ISSUE_ASSIGNED_EVENT,
	ISSUE_CREATED_EVENT,
	ISSUE_DELETED_EVENT,
	ISSUE_TRANSITIONED_EVENT,
	ISSUE_UPDATED_EVENT,
	ISSUE_PARENT_ASSOCIATION_EVENT,
];

export const BACKLOG = 'BACKLOG';
export const BOARD = 'BOARD';
export const SPRINT = 'SPRINT';

// below data also defined in the backlog app src/packages/software/backlog/src/common/constants/index.js
export const DND_DROP_ZONES_ACTIVE_SPRINT = 'activeSprint';
export const DND_DROP_ZONES_FUTURE_SPRINT = 'futureSprint';
export const DND_DROP_ZONES_SPRINT = 'sprint';
export const DND_DROP_ZONES_BOARD = 'board';
export const DND_DROP_ZONES_BACKLOG = 'backlog';
export const DND_DROP_ZONES_EPIC_PANEL = 'epicPanel';
export const DND_DROP_ZONES_VERSION_PANEL = 'versionPanel';

export const DND_TARGET_BACKLOG_CARD = 'backlogCard';
export const DND_TARGET_EPIC_PANEL_CARD = 'epicPanelCard';
export const DND_TARGET_VERSION_PANEL_CARD = 'versionPanelCard';
export const DND_TARGET_DIVIDER = 'divider';

export const DND_OPERATION_CARD_PARENT_SET = 'cardParentSet';
export const DND_OPERATION_CARD_PARENT_UNSET = 'cardParentUnset';
export const DND_OPERATION_EPIC_RANK_UPDATE = 'epicRankUpdate';

export const EPIC_CARD_DESCRIPTION_ID = 'epicCardDescriptionId';

// Backlog card list stops fitting inside the viewport at this width
// with both version & epic panels open, no issue open, and sidebar uncollapsed.
export const COMPACT_BREAKPOINT = 1510;

export const PAGE_SIZE = 100;
